import CarouselSlide from "design-system/resources/assets/js/carouselSlide";

export default function getIdCarouselForSlide() {
    const allCarouselsSelector =  document.querySelectorAll('.carousel-slide');
  
    allCarouselsSelector && allCarouselsSelector.forEach((e)=> {
      var currId = e.getAttribute('id');
      if(currId) {
        CarouselSlide("#" + currId);
      }
    })
  }